/*
  Deferred featured-collection carousels.

  /pages/shop-by-collection stacks 17 of them and renders 102 product cards in one pass —
  ~4.7s and 1.0MB, against ~1.3s for the same page with the carousels removed. Everything
  past the first two now renders a placeholder and is fetched here when it nears the
  viewport. One section alone renders in ~0.35s, well clear of the Liquid render ceiling
  that was returning a 500 for ~12% of uncached requests.

  Served as a file rather than inlined so the page carries one <script src> per deferred
  section (~100 bytes each, fetched once) instead of fifteen copies of this logic.
*/
(function () {
  if (window.__fcDeferInit) return;
  window.__fcDeferInit = true;

  function load(el) {
    var id = el.getAttribute('data-fc-defer');
    if (!id || el.dataset.fcLoaded) return;
    el.dataset.fcLoaded = '1';

    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), {
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The API returns the whole <section> wrapper. Swap in its CONTENTS, so we do not
        // nest a second shopify-section element inside the one already on the page.
        var incoming =
          doc.getElementById('shopify-section-' + id) || doc.body;
        var host = el.closest('.container-background') || el;
        if (!incoming || !incoming.childNodes.length || !host.parentNode) return;

        var frag = document.createDocumentFragment();
        while (incoming.firstChild) frag.appendChild(incoming.firstChild);

        // Scripts injected via innerHTML/adoptNode do not execute. Flickity initialises
        // from its own custom element, so re-registering is not needed — but any inline
        // script the section carries must be re-created to run.
        var scripts = frag.querySelectorAll ? frag.querySelectorAll('script') : [];
        Array.prototype.forEach.call(scripts, function (old) {
          var s = document.createElement('script');
          if (old.src) s.src = old.src;
          else s.textContent = old.textContent;
          old.parentNode.replaceChild(s, old);
        });

        host.parentNode.replaceChild(frag, host);
      })
      .catch(function () {
        // Leave the placeholder and its collection link in place. A failed fetch must not
        // remove the way through to the products.
      });
  }

  function start() {
    var nodes = document.querySelectorAll('[data-fc-defer]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, load);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            io.unobserve(e.target);
            load(e.target);
          }
        });
      },
      // Start fetching before it is on screen, so the swap is not visible while scrolling.
      { rootMargin: '600px 0px' }
    );

    Array.prototype.forEach.call(nodes, function (n) {
      io.observe(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
